import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import AccountEventType from '@/plugins/sdk/resources/Account/Event/Type'
import AccountEventDefer from '@/plugins/sdk/resources/Account/Event/Defer'

export default class extends Resource {
  static name = 'account_event'

  static get fields () {
    return {
      id: new UUID(),
      account: new ITEM(Account),
      priority: new STRING(),
      type: new ITEM(AccountEventType),
      defers: new COLLECTION(AccountEventDefer),
      due_at: new DATETIME(),
      completed_at: new DATETIME(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
